import { computed, ref, Ref } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/dist/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/dist/src/interfaces/options.interface';
import { Currency } from '@studyportals/campaign-management-api-interface';
import { ValidationProperties } from '@/models/validation.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class CurrencyCode {
	public currencyDropdown: Ref<IMultiSelect | null> = ref(null);
	public options: IOption[] = [
		{ label: Currency.EUR, value: Currency.EUR },
		{ label: Currency.GBP, value: Currency.GBP },
		{ label: Currency.USD, value: Currency.USD },
		{ label: Currency.AUD, value: Currency.AUD },
		{ label: Currency.CAD, value: Currency.CAD }
	];

	public isCampaignCreation = computed((): boolean => {
		return store.getters.isCampaignCreation();
	});

	public currency = computed((): Currency | null => {
		return store.getters.currency();
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.CURRENCY);
	});

	private isCurrencySet = computed((): boolean => {
		return this.currency.value !== null;
	});

	public mounted(): void {
		this.prefillCurrency();
	}

	public setCurrency(option: IOption): void {
		store.mutations.setCurrency(option.value as Currency);

		if (!this.isFieldValidatedAndMissing.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}

	private prefillCurrency(): void {
		if (!this.currencyDropdown.value || !this.isCurrencySet.value) {
			return;
		}

		const selectedOption = this.options.find((option) => option.value === this.currency.value);
		if (!selectedOption) {
			return;
		}

		this.currencyDropdown.value.selectOption(selectedOption);
	}
}
